<template>
    <footer class="w-full bg-[#11111b] text-white border-t border-gray-800 py-6 min-h-fit max-h-none overflow-hidden">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div class="flex justify-center space-x-6 mb-4">
                <a :href="heroData.facebookURL" target="_blank" class="text-gray-400 hover:text-white">
                    <span class="sr-only">Facebook</span>
                    <Facebook class="w-6 h-6" />
                </a>
                <a :href="heroData.githubURL" target="_blank" class="text-gray-400 hover:text-white">
                    <span class="sr-only">GitHub</span>
                    <Github class="w-6 h-6" />
                </a>
                <a :href="heroData.linkedinURL" target="_blank" class="text-gray-400 hover:text-white">
                    <span class="sr-only">LinkedIn</span>
                    <Linkedin class="w-6 h-6" />
                </a>
                <a :href="heroData.telegramURL" target="_blank" class="text-gray-400 hover:text-white">
                    <span class="sr-only">Telegram</span>
                    <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <path fill="currentColor"
                            d="m29.919 6.163l-4.225 19.925c-.319 1.406-1.15 1.756-2.331 1.094l-6.438-4.744l-3.106 2.988c-.344.344-.631.631-1.294.631l.463-6.556L24.919 8.72c.519-.462-.113-.719-.806-.256l-14.75 9.288l-6.35-1.988c-1.381-.431-1.406-1.381.288-2.044l24.837-9.569c1.15-.431 2.156.256 1.781 2.013z" />
                    </svg>
                </a>
            </div>
            <p class="text-sm text-gray-500">&copy; 2022 Borenn Morm. All rights reserved.</p>
        </div>
    </footer>
</template>

<script setup>
import { Facebook, Github, Linkedin } from 'lucide-vue-next';
import { projectFirestore } from '@/firebase/config.js';
import { collection, query, limit, getDocs } from 'firebase/firestore';
import { reactive, onMounted } from 'vue';


const heroData = reactive({
    telegramURL: null,
    githubURL: null,
    facebookURL: null,
    linkedinURL: null
});
const isLoading = reactive({ value: true });
const error = reactive({ value: null });

const loadHeroData = async () => {

    try {
        const q = query(collection(projectFirestore, 'heroes'), limit(1));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const data = querySnapshot.docs[0].data();
            Object.assign(heroData, {
                telegramURL: data.telegramURL || null,
                githubURL: data.githubURL || null,
                facebookURL: data.facebookURL || null,
                linkedinURL: data.linkedinURL || null

            });
        } else {
            error.value = 'Profile data not found';
        }
    } catch (err) {
        console.error('Error loading hero:', err);
        error.value = `Failed to load profile: ${err.message}`;
    } finally {
        isLoading.value = false;
    }
};

onMounted(() => {
    loadHeroData();
});



</script>

<style scoped>
footer {
    position: relative;
    bottom: 0;
    width: 100%;
    height: auto;
    flex-shrink: 0;
}
</style>